import { Observable, interval } from 'rxjs';
import { Injectable } from '@angular/core';
import { map, share } from 'rxjs/operators';
import * as moment from 'moment';

@Injectable({
  providedIn: 'root'
})
export class TimingService {

  public clock$: Observable<any> = null;

  constructor() {
    this.clock$ = interval(1000).pipe(
      map(() => {
        return moment();
      }),
      share()
    );
  }

}
